import { gql } from '@apollo/client';
import { ErrorMessageInfo } from '@retainerclub/shared-api';

export default gql`
  mutation actionGenerateDisputePackage($input: GenerateDisputePackageActionInput!) {
    actionGenerateDisputePackage(input: $input) {
      clientMutationId
      errorMessages {
        ...ErrorMessageInfo
      }
      success
      url
    }
  }
  ${ErrorMessageInfo}
`;
